import { ILaunchpad } from '@tacans/shared-marketplace-layer';
import dayjs from 'dayjs';
import { useProfile } from 'src/features/common/profile/hooks/profile.hooks';

export const useCheckLaunchpadAccess = ({ launchpad }: { launchpad?: ILaunchpad }) => {
    const profile = useProfile();

    if (!launchpad) {
        return false;
    }

    const mintDate = dayjs(launchpad.mintDate);
    const isExpired = dayjs().isAfter(mintDate);
    const isActive = isExpired && launchpad.isEnabled;
    const isOwner = profile && profile?.user?.id === launchpad?.ownerId;

    return isOwner || isActive;
};
